import { getAuthTokenFromCookie } from 'src/models/auth/lmsLogin/queries';
import { isJsonString } from 'src/workspace/utils';
import { DEFAULT_ERROR_MESSAGE } from './constants';

export const getDecodedAccessToken = (accessToken?: string) => {
  if (!accessToken) {
    return '';
  }

  try {
    return decodeURIComponent(accessToken);
  } catch {
    return accessToken;
  }
};

export const getAuthRedirectErrorMessage = (error: any) =>
  error?.message || DEFAULT_ERROR_MESSAGE;

export const getStoredAuthToken = () => getAuthTokenFromCookie() || '';

export const getAuthRedirectQueryParams = (
  searchParams: URLSearchParams,
): Record<string, any> => {
  const value = searchParams.get('value');

  if (!value || !isJsonString(value)) {
    return {};
  }

  return JSON.parse(value);
};

export const getAuthRedirectPayload = (searchParams: URLSearchParams) => {
  const {
    client_id: clientId,
    access_token: accessToken,
    oneTapLogin,
  } = getAuthRedirectQueryParams(searchParams);

  return {
    redirectErrorMessage: searchParams.get('error'),
    clientId,
    accessToken,
    oneTapLogin,
  };
};
